import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text, Group } from '@mantine/core';
import { IconMail, IconWebhook, IconMessage } from '@tabler/icons-react';

function ActionNode({ data, selected }: NodeProps) {
  const getActionIcon = () => {
    if (!data.action) return <IconWebhook size={14} />;

    switch (data.action.type) {
      case 'Email':
        return <IconMail size={14} />;
      case 'Webhook':
        return <IconWebhook size={14} />;
      case 'Sms':
        return <IconMessage size={14} />;
      default:
        return <IconWebhook size={14} />;
    }
  };

  const getActionLabel = () => {
    if (!data.action) return 'Action';
    return data.action.type || 'Action';
  };

  return (
    <Box
      style={{
        background: 'white',
        border: `2px solid ${selected ? '#3b82f6' : '#e5e7eb'}`,
        borderRadius: '6px',
        padding: '8px 12px',
        minWidth: '140px',
        boxShadow: selected ? '0 4px 12px rgba(59, 130, 246, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Handle type="target" position={Position.Top} />
      <Group gap="xs" wrap="nowrap">
        <Box
          style={{
            background: '#3b82f6',
            borderRadius: '4px',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {getActionIcon()}
        </Box>
        <Box style={{ flex: 1 }}>
          <Text size="xs" fw={600} lineClamp={1}>
            {getActionLabel()}
          </Text>
        </Box>
      </Group>
      <Handle type="source" position={Position.Bottom} />
    </Box>
  );
}

export default memo(ActionNode);
